import { Button, Col, Row } from "react-bootstrap";
import type {
    IListSourceExtractionFieldResult,
    IWasteReturnTemplateMapping,
} from "../../customTypings/spreadsheetTemplate/SpreadsheetTemplate";
import { RegDataComparisonPanel } from "./regDataAlignment/RegDataComparisonPanel";
import { RegDataUnresolvedSourcesPanel } from "./RegDataUnresolvedSourcesPanel";

export interface WasteReturnSyncStepProps {
    hasActiveTemplate: boolean;
    hasMapping: boolean;
    mapping: IWasteReturnTemplateMapping;
    sheetOptions: string[];
    extractionFields: Record<string, IListSourceExtractionFieldResult>;
    alignmentReloadToken: number;
    resolvingFieldKey: string | null;
    disabled?: boolean;
    onResolveSource: (
        fieldKey: string,
        sheet: string,
        valueRange: string,
        adjacentColumns?: Record<string, string>
    ) => void;
    onContinue?: () => void;
}

export function WasteReturnSyncStep({
    hasActiveTemplate,
    hasMapping,
    mapping,
    sheetOptions,
    extractionFields,
    alignmentReloadToken,
    resolvingFieldKey,
    disabled,
    onResolveSource,
    onContinue,
}: WasteReturnSyncStepProps) {
    return (
        <>
            <RegDataUnresolvedSourcesPanel
                mapping={mapping}
                sheetOptions={sheetOptions}
                extractionFields={extractionFields}
                resolvingFieldKey={resolvingFieldKey}
                disabled={disabled}
                onResolve={onResolveSource}
            />

            <RegDataComparisonPanel
                hasActiveTemplate={hasActiveTemplate}
                hasMapping={hasMapping}
                mapping={mapping}
                reloadToken={alignmentReloadToken}
            />

            {onContinue && (
                <Row className="mb-4 justify-content-end">
                    <Col xs="auto">
                        <Button variant="primary" onClick={onContinue} disabled={disabled}>
                            Continue to validate & save
                        </Button>
                    </Col>
                </Row>
            )}
        </>
    );
}
